import { asPlantId } from '../../../access';
import type { PeopleListFilters } from '../utils/query-keys';

export const directoryFiltersOf = (q: string, plant: string): PeopleListFilters => ({
  q: q || undefined,
  plantId: plant ? asPlantId(plant) : undefined,
});

export const plantPeopleFiltersOf = (q: string, plantId: string): PeopleListFilters => ({
  q: q || undefined,
  plantId: asPlantId(plantId),
});
